import { Box } from "@mui/material";
import { isAndroidPlatform } from "@src/appV2/lib";
import blackPixelImage from "public/assets/images/black-pixel.png";
import { useEffect, useState } from "react";

interface VideoPreviewPlayerProps {
  recordedVideoUrl: string | undefined;
}

export function VideoPreviewPlayer(props: VideoPreviewPlayerProps) {
  const { recordedVideoUrl } = props;
  const [recordedVideoElementRef, setRecordedVideoElementRef] = useState<HTMLVideoElement>();

  const isAndroid = isAndroidPlatform();

  // Required to load the preview frame before the video plays
  useEffect(() => {
    recordedVideoElementRef?.load();
  }, [recordedVideoElementRef]);

  return (
    <Box
      sx={{
        "& video": {
          background: (theme) => theme.palette.common.black,
          maxWidth: "100%",
          maxHeight: "55vh",
          display: "block",
          aspectRatio: "9 / 16",
          margin: "auto",
          objectFit: "contain",
          borderRadius: "16px",
          height: "100%",
        },
      }}
    >
      <video
        ref={(ref) => {
          setRecordedVideoElementRef(ref ?? undefined);
        }}
        controls
        playsInline
        disablePictureInPicture
        disableRemotePlayback
        preload="auto"
        // To force android to load a poster image
        src={isAndroid ? `${recordedVideoUrl}#t=0.1` : recordedVideoUrl}
        // To prevent android from showing askewed play icon until video loads
        poster={isAndroid ? blackPixelImage : undefined}
        onLoadedData={(event) => {
          if (event.currentTarget.hasAttribute("poster")) {
            event.currentTarget.removeAttribute("poster");
          }
        }}
      />
    </Box>
  );
}
